var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32 14.504L4.48 17.6226L1.42998 17.6926C0.503598 15.9733 0.0111884 14.0539 -0.004496 12.1011C-0.0201805 10.1483 0.441338 8.22125 1.33999 6.48727L4.05999 6.98707L5.24999 9.68595C4.71799 11.2522 4.74272 12.9539 5.32 14.504Z",
    fill: "#FBBB03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.79 9.76593C24.1966 11.905 24.013 14.1143 23.259 16.1569C22.505 18.1996 21.209 19.9986 19.51 21.3611L16.09 21.1812L15.6 18.1824C17.017 17.3532 18.1047 16.0612 18.68 14.524H12.26V9.78594L23.79 9.76593Z",
    fill: "#5C84C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.51 21.4011C18.2809 22.3869 16.8695 23.1211 15.3564 23.5618C13.8434 24.0024 12.2584 24.1408 10.6918 23.9691C9.12529 23.7973 7.60795 23.3189 6.22641 22.561C4.84487 21.8031 3.62621 20.7805 2.64001 19.5518C2.18322 18.9827 1.77825 18.3739 1.42999 17.7326L5.32001 14.5439C5.98461 16.316 7.32612 17.7516 9.0495 18.5352C10.7729 19.3187 12.737 19.386 14.51 18.7222C14.8854 18.5753 15.2496 18.4016 15.6 18.2024L19.51 21.4011Z",
    fill: "#3DAC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.66 2.76885L15.77 5.94755C14.1626 4.94891 12.2242 4.62905 10.381 5.05827C8.53774 5.48749 6.94039 6.63066 5.93997 8.23657C5.66013 8.69438 5.42887 9.18016 5.24997 9.68598L1.33997 6.4873C2.06442 5.08758 3.05772 3.84428 4.26309 2.82846C5.46846 1.81263 6.86229 1.04418 8.3649 0.567038C9.86751 0.0898941 11.4494 -0.0865871 13.0203 0.047662C14.5912 0.181911 16.1202 0.624272 17.52 1.34946C18.2812 1.74621 18.9985 2.22195 19.66 2.76885Z",
    fill: "#E84539"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2d54c254ba792652a00403eddab36dcd.svg";
export { ForwardRef as ReactComponent };